import { Mapper } from 'src/base/mapper'
import { ProductActiveTypeEntity } from 'src/data/entities/product.entity'
import { ProductActiveTypeModel } from 'src/domain/models/product.model'

export class ProductActiveMapper extends Mapper<ProductActiveTypeEntity, ProductActiveTypeModel> {
	mapFrom(param: ProductActiveTypeEntity): ProductActiveTypeModel {
		return {
			productId: param.productId,
			productName: param.productName,
			isActive: param.isActive,
		}
	}

	mapTo(param: ProductActiveTypeModel): ProductActiveTypeEntity {
		return {
			productId: param.productId,
			productName: param.productName,
			productDescription: null,
			isActive: param.isActive,
			createdByUserId: null,
			dateCreated: null,
			updatedByUserId: null,
			dateUpdated: null,
			plans: null,
			productItems: null,
		}
	}
}
